import dibsCss from 'dibs-css';
import classnames from 'classnames';
import { type FC, useId } from 'react';

type NftLogoProps = {
    className?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const NftLogo: FC<NftLogoProps> = props => {
    const id = useId();
    const labelledby = props.ariaLabelledby ? `${id} ${props.ariaLabelledby}` : id;
    return (
        <svg
            className={classnames(dibsCss.dibsIcon, props.className)}
            data-tn={'nft-logo'}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={labelledby}
            data-name="Layer 1"
            viewBox="0 0 500.3 200.8"
        >
            <title id={id}>NFT</title>
            <path d="M125.3 200.8l-52.2-89.1C54.5 80.1 36.7 49.1 18.7 18.3h-.6c0 33.6.3 66.9.3 100.4v82.1H0V0h28l52.1 89.1c18.6 31.6 36.4 62.6 54.5 93.4h.5c-.3-33.6-.3-66.9-.3-100.4V0h18.4v200.8z" />
            <path d="M205.9 16.6v75.9h97.6v16.6h-97.6v91.7h-18.3V0h122.1v16.6z" />
            <path d="M428.7 16.6v184.2h-18.3V16.6H339V0h161.4v16.6z" />
        </svg>
    );
};

export default NftLogo;
